// extracted by mini-css-extract-plugin
export default {"side":"SideNavLayout_side__1bLQw","placeHolderShimmer":"SideNavLayout_placeHolderShimmer__Q3pNF"};